import { useState } from "react";
import styles from "./ordernacaoProdutos.module.css";
import IconesNovos from "../NewIcones/IconesNovos";
import "animate.css";

type Props = {
  orderBy: string;
  onSelectOrderBy: (order: string) => void;
};

export function OrdenacaoProdutos({ orderBy, onSelectOrderBy }: Props) {
  const [openOrderModal, setOpenOrderModal] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  function handleCloseModal() {
    setIsAnimating(true); // Inicia a animação de fechamento
    setOpenOrderModal(false); // Fecha o modal
  }

  return (
    <>
      {(openOrderModal || isAnimating) && (
        <div
          className={
            styles.order_container_wrapper +
            ` animate__animated ${openOrderModal ? `animate__fadeInDown` : "animate__fadeOutUp"}`
          }
          onAnimationEnd={() => {
            if (!openOrderModal) setIsAnimating(false); // Remove do DOM após a animação de fechamento
          }}
        >
          <div
            className={styles.order_container_overlay}
            onClick={handleCloseModal}
          ></div>
          <div className={styles.order_container}>
            <div
              className={styles.options_container}
              onClick={() => {
                onSelectOrderBy("name-asc");
                setOpenOrderModal(false);
              }}
            >
              <span onClick={() => onSelectOrderBy("name-asc")}>Nome A-Z</span>
              <input
                type="radio"
                name="product_order"
                value={"name-asc"}
                className={styles.option_input}
                onClick={() => {
                  onSelectOrderBy("name-asc");
                }}
                checked={orderBy === "name-asc"}
              />
            </div>
            <div
              className={styles.options_container}
              onClick={() => {
                onSelectOrderBy("name-desc");
                setOpenOrderModal(false);
              }}
            >
              <span onClick={() => onSelectOrderBy("name-desc")}>Nome Z-A</span>
              <input
                type="radio"
                name="product_order"
                value={"name-desc"}
                className={styles.option_input}
                onClick={() => {
                  onSelectOrderBy("name-desc");
                }}
                checked={orderBy === "name-desc"}
              />
            </div>
            <div
              className={styles.options_container}
              onClick={() => {
                onSelectOrderBy("price-asc");
                setOpenOrderModal(false);
              }}
            >
              <span onClick={() => onSelectOrderBy("price-asc")}>
                Menor Preço
              </span>
              <input
                type="radio"
                name="product_order"
                value={"price-asc"}
                className={styles.option_input}
                onClick={() => {
                  onSelectOrderBy("price-asc");
                }}
                checked={orderBy === "price-asc"}
              />
            </div>
            <div
              className={styles.options_container}
              onClick={() => {
                onSelectOrderBy("price-desc");
                setOpenOrderModal(false);
              }}
            >
              <span onClick={() => onSelectOrderBy("price-desc")}>
                Maior Preço
              </span>
              <input
                type="radio"
                name="product_order"
                value={"price-desc"}
                checked={orderBy === "price-desc"}
                className={styles.option_input}
                onClick={() => {
                  onSelectOrderBy("price-desc");
                }}
              />
            </div>

            <div
              className={styles.options_container}
              onClick={() => {
                onSelectOrderBy("price-promo-asc");
                setOpenOrderModal(false);
              }}
            >
              <span onClick={() => onSelectOrderBy("price-promo-asc")}>
                Menor Preço Promocional
              </span>
              <input
                type="radio"
                name="product_order"
                value={"price-promo-asc"}
                checked={orderBy === "price-promo-asc"}
                className={styles.option_input}
                onClick={() => {
                  onSelectOrderBy("price-promo-asc");
                }}
              />
            </div>

            <div
              className={styles.options_container}
              onClick={() => {
                onSelectOrderBy("price-promo-desc");
                setOpenOrderModal(false);
              }}
            >
              <span onClick={() => onSelectOrderBy("price-promo-desc")}>
                Maior Preço Promocional
              </span>
              <input
                type="radio"
                name="product_order"
                value={"price-promo-desc"}
                checked={orderBy === "price-promo-desc"}
                className={styles.option_input}
                onClick={() => {
                  onSelectOrderBy("price-promo-desc");
                }}
              />
            </div>
            <div
              className={styles.options_container}
              onClick={() => {
                onSelectOrderBy("created-asc");
                setOpenOrderModal(false);
              }}
            >
              <span onClick={() => onSelectOrderBy("price-desc")}>
                Mais Antigo
              </span>
              <input
                type="radio"
                name="product_order"
                value={"created-asc"}
                checked={orderBy === "created-asc"}
                className={styles.option_input}
                onClick={() => {
                  onSelectOrderBy("created-asc");
                }}
              />
            </div>
            <div
              className={styles.options_container}
              onClick={() => {
                onSelectOrderBy("created-desc");
                setOpenOrderModal(false);
              }}
            >
              <span onClick={() => onSelectOrderBy("created-desc")}>
                Mais Recente
              </span>
              <input
                type="radio"
                name="product_order"
                value={"created-desc"}
                checked={orderBy === "created-desc"}
                className={styles.option_input}
                onClick={() => {
                  onSelectOrderBy("created-desc");
                }}
              />
            </div>
          </div>
        </div>
      )}

      <button
        className={styles.filter_button}
        onClick={() => setOpenOrderModal(true)}
      >
        <IconesNovos
          cor={"#636363"}
          active={true}
          type={"order_small"}
          action={() => null}
        />
        Ordenar
      </button>
    </>
  );
}
